(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/map-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/map-start.js');

'use strict';

const {
  useEffect,
  useMemo
} = React;
const {
  getStartMapHandler
} = svs.lyckoplatsen.components.shared_map;
const MapStart = () => {
  const mapHandlerStart = useMemo(getStartMapHandler, []);
  const mapId = 'map-start';
  useEffect(() => {
    var _svs;
    const eventHandler = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.components) === null || _svs === void 0 || (_svs = _svs.onboarding) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.events) === null || _svs === void 0 || (_svs = _svs.eventHandlers) === null || _svs === void 0 ? void 0 : _svs.createFullscreenEventHandler();
    if (!eventHandler) {
      return;
    }
    const {
      addEventListener: addFullscreenEventListener,
      removeEventListener: removeFullscreenEventListener
    } = eventHandler;
    const onShowFullscreen = () => {
      mapHandlerStart.animateReset();
    };
    const onHideFullscreen = () => {
      mapHandlerStart.animatePlay();
    };
    addFullscreenEventListener(svs.components.onboarding.core.events.constants.FullscreenEventType.Show, onShowFullscreen);
    addFullscreenEventListener(svs.components.onboarding.core.events.constants.FullscreenEventType.Hide, onHideFullscreen);
    return () => {
      removeFullscreenEventListener(svs.components.onboarding.core.events.constants.FullscreenEventType.Show, onShowFullscreen);
      removeFullscreenEventListener(svs.components.onboarding.core.events.constants.FullscreenEventType.Hide, onHideFullscreen);
    };
  }, [mapHandlerStart]);
  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      dragging: false,
      zoomSnap: 0.1,
      minZoom: 1,
      zoomControl: false,
      scrollWheelZoom: false,
      geoJsonInv: true,
      geoJson: true,
      addGradients: true
    };
    mapHandlerStart.createMap(mapOptions);
    return () => {
      mapHandlerStart.removeMap();
    };
  }, [mapHandlerStart]);
  return React.createElement("div", {
    id: mapId,
    className: "lp-map-start",
    style: {
      height: '100%',
      width: '100%',
      zIndex: 0
    }
  });
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  MapStart
});

 })(window);